import { createStyles, rem } from '@mantine/core'

interface StylesParams {
  bannerColor: string
  bgSessionColor?: string
}

export default createStyles(
  (theme, { bgSessionColor, bannerColor }: StylesParams) => {
    return {
      root: {},
      banner: {
        padding: rem(12),
        backgroundColor: bannerColor,
        ...(bgSessionColor === bannerColor && {
          border: `1px solid ${theme.colors.neutral[1]}`,
        }),
        borderRadius: rem(12),
        height: '100%',
        [theme.fn.smallerThan('sm')]: {
          padding: rem(8),
        },
      },
      bannerIframe: {},
      title: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 1,
        ' > *': {
          // line-height: 36px; /* set the line height to half the element height (72px / 2) */
          overflow:
            'hidden' /* hide any text that exceeds the maximum height */,
          textOverflow:
            'ellipsis' /* add ellipsis to indicate that the text has been truncated */,
          display:
            ' -webkit-box' /* use the old webkit syntax for line-clamp */,
          '-webkit-line-clamp': 2 /* clamp the text to 2 lines */,
          ' -webkit-box-orient':
            'vertical' /* set the box orientation to vertical */,
        },
        [theme.fn.smallerThan('sm')]: {
          height: 'initial',
        },
      },
    }
  },
)
